import {
  Container,
  Title,
  Text,
  SimpleGrid,
  Paper,
  Stack,
  Group,
} from "@mantine/core";
import { IconUsers, IconBulb, IconTrendingUp } from "@tabler/icons-react";

import { useEffect, useState } from "react";
import { Endpoints } from "../../../lib/endpoints";
import { PerformRequest } from "../../../lib/usePerformRequest";
import { IAnalyticsStats } from "../../../lib/types/Admin";

export default function Overview() {
  const [visitorStats, setVisitorStats] = useState<{
    total: number;
    today: number;
  }>({ total: 0, today: 0 });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await PerformRequest<IAnalyticsStats>({
          method: Endpoints.GetVisitorStats().method,
          route: Endpoints.GetVisitorStats().route,
        });
        if (response.data && response.data.summary) {
          setVisitorStats({
            total: response.data.summary.total,
            today: response.data.summary.today,
          });
        }
      } catch (error) {
        console.error("Failed to fetch visitor stats", error);
      }
    };
    fetchStats();
  }, []);

  const stats = [
    {
      title: "Total Tips",
      value: "20",
      icon: IconBulb,
      color: "blue",
    },
    {
      title: "Active Users",
      value: "1,234",
      icon: IconUsers,
      color: "green",
    },
    {
      title: "Total Unique Visitors",
      value: visitorStats.total.toString(),
      icon: IconUsers,
      color: "indigo",
    },
    {
      title: "Visitors Today",
      value: visitorStats.today.toString(),
      icon: IconTrendingUp,
      color: "grape",
    },
    {
      title: "Growth Rate",
      value: "+12%",
      icon: IconTrendingUp,
      color: "orange",
    },
  ];

  return (
    <Container size="xl">
      <Stack gap="xl">
        <div>
          <Title order={2} mb="xs">
            Overview
          </Title>
          <Text c="dimmed">
            Welcome to your admin dashboard. Here's a quick overview of your
            activity.
          </Text>
        </div>

        <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="lg">
          {stats.map((stat) => {
            const Icon = stat.icon;
            return (
              <Paper key={stat.title} p="xl" shadow="xs" radius="md" withBorder>
                <Stack gap="xs">
                  <Group justify="space-between">
                    <Icon
                      size={32}
                      color={`var(--mantine-color-${stat.color}-6)`}
                    />
                    <Text size="xs" c="dimmed">
                      {stat.title}
                    </Text>
                  </Group>
                  <Text size="xl" fw={700}>
                    {stat.value}
                  </Text>
                </Stack>
              </Paper>
            );
          })}
        </SimpleGrid>
      </Stack>
    </Container>
  );
}
